import React from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CheckBoxOutlineBlankOutlinedIcon from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import DeleteIcon from '@material-ui/icons/Delete';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from '@material-ui/core/Tooltip';
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Link from "@material-ui/core/Link";

import TaskList from "../task/TaskList";
import SelectUser from "../user/SelectUser";
import SelectCategory from "./SelectCategory";
import ConfirmationDialog from "../components/ConfirmationDialog";
import SetTimeDialog from "../components/SetTimeDialog";
import Members from "./Members";

import './RequirementDetails.css';

/**
 * props:
 * styles
 * element
 * version
 * showTasks
 * state
 * newRequirement
 * newTask
 * remove
 * onRequirementUpdate
 * onStartMove
 * onClose
 * move
 * create: true to create a new requirement
 */
class RequirementDetails extends React.Component {
    constructor(props) {
        super(props);
        console.log("RequirementDetails:", props);

        this.state = {
            editName: this.props.create,
            editDescription: false,
            confirmationOpen: false,
            setTimeOpen: false,
            updatedTime: new Date(),
        };

        this._handleTextFieldChange = this._handleTextFieldChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);

        this.cancel = this.cancel.bind(this);
        this.save = this.save.bind(this);
        this.elementUpdated = this.elementUpdated.bind(this);
        this.onSetTime = this.onSetTime.bind(this);

        this.remove = this.remove.bind(this);
        this.removeCancel = this.removeCancel.bind(this);
        this.removeOK = this.removeOK.bind(this);

        this.createTask = this.createTask.bind(this);
        this.removeTask = this.removeTask.bind(this);

        this.styles = props.styles;
    }

    render() {
        const element = this.props.element;
        const elementType = element.type === 'Requirement' ? element.requirementType : element.type;
        const typeName = element.type === 'Requirement' ? this.props.metamodel.requirement.name : element.type;
        const changed = this.state;

        let description;
        if(changed.description !== null && changed.description !== undefined) {
            description = changed.description;
        } else if(element.description) {
            description = element.description;
        } else {
            description = "";
        }

        const values = {
            name: changed.name !== undefined ? changed.name : element.name,
            type: changed.type || elementType,
            description: description,
            status: changed.status || element.status,
            assigned: changed.assigned || (element.assigned && element.assigned[0] ? element.assigned[0] : undefined),
            version: this.state.version,
        };

        let elementStatus = this.state.status || element.status;

        let plannedDates = "";
        let plannedDatesStyle = {
            marginLeft: "12px",
        };

        if(!element.hasOwnProperty('plannedStart')) {
            plannedDatesStyle.display = "none";
        } else if(element.status === 'Done') {
            plannedDatesStyle.visibility = "hidden";
        } else {
            if(element.plannedStart || element.deadline) {
                if (element.plannedStart) {
                    plannedDates = (element.deadline ? "" : "Start: ") + element.plannedStart;

                    // if(element.status === 'Future' && element.plannedStartIsNow) {
                    //     plannedDates += " (can be started now)"
                    // }
                }
                if (element.deadline) {
                    plannedDates = (plannedDates ? plannedDates + " - " : "Deadline: ") + element.deadline;

                    // if(element.status !== 'Done' && element.deadlineIsNow) {
                    //     plannedDates += " (should be done now)"
                    // }
                }
            } else {
                plannedDates = "No planned dates."
            }
        }

        const editCategory = this.props.create && !this.props.parent;
        const showButtons = (!this.state.editName && !this.state.editDescription);
        const metamodelRequirements = this.props.metamodel.requirement;

        return (
            <div>
                {false && element.type === 'Requirement' && <AddOutlinedIcon className="icon" /> }
                {false && element.type === 'Task' && <CheckBoxOutlineBlankOutlinedIcon className="icon" /> }
                {editCategory &&
                    <div className="parent">
                        <SelectCategory
                            id="parent"
                            categories={this.props.categories}
                            selection={this.state.parent}
                            onSelect={(id, value) => {
                                console.log("RequirementDetails selected category:", id, value);
                                var newState = {};
                                newState[id] = value;
                                this.setState(newState);
                            }}
                        />
                    </div>
                }
                {this.state.editName ?
                    <TextField id='name'
                               className="name-edit"
                               value={values.name}
                               placeholder="New goal"
                               onChange={this._handleTextFieldChange}
                               autoFocus={true}
                               InputProps={{
                                   style: {
                                       fontWeight: 'bold',
                                   }
                               }}
                    /> :
                    <span className="name-read"
                          onClick={() => {this.setState({editName: true} ) }}>
                        {values.name}
                    </span>
                }
                {!this.props.create &&
                    <div className="close">
                        <Tooltip title="Close">
                            <IconButton aria-label="add" onClick={this.props.onClose}>
                                <CloseIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                }
                {/*this.props.filter && this.props.filter.status === 'To do' &&
                    <span style={{float: "right"}}>{'ID: ' + element.id}</span>
                */}
                {!this.state.editDescription &&
                    <div className="description-read"
                         onClick={() => {this.setState({editDescription: true} ) }}
                    >
                        {
                            values.description.split('\n').map((line, index) =>
                                line ?
                                    <div key={index}>{line}</div> :
                                    <div key={index}>&nbsp;</div>
                            )
                        }
                    </div>
                }
                {this.state.editDescription &&
                    <TextField id='description'
                               className="description-edit"
                               variant="outlined"
                               fullWidth
                               multiline
                               autoFocus={true}
                               value={values.description}
                               onChange={this._handleTextFieldChange}
                    />
                }

                <div>
                    {elementType === 'Task' &&
                        <span>
                            Assigned to:&nbsp;
                            <SelectUser
                                id="assigned"
                                className="assigned"
                                users={this.props.users}
                                userMap={this.props.userMap}
                                selected={element.assigned && element.assigned[0] ? element.assigned[0] : undefined}
                                edit={true}
                                onSelect={this.handleSelect}
                            />
                        </span>
                    }

                    <span className="members">
                        <Members
                            label="Members"
                            element={element}
                            user={this.props.user}
                            globals={this.props.globals}
                            elementUpdated={this.elementUpdated}
                        />
                    </span>

                    <div className="buttons">
                        {showButtons ?
                            <div className="leftButtons">
                                {values.status && (element.type !== 'Task' ?
                                    <ToggleButtonGroup
                                        value={elementStatus}
                                        exclusive
                                        onChange={this.handleStatusChange}
                                        aria-label="text alignment"
                                    >
                                        {
                                            Object.keys(metamodelRequirements.values || []).map((i) =>
                                                <ToggleButton
                                                    key={i}
                                                    value={metamodelRequirements.values[i]}
                                                    className="toggle"
                                                >
                                                    {
                                                        metamodelRequirements.labels[ metamodelRequirements.values[i] ]
                                                    }
                                                </ToggleButton>
                                            )
                                        }
                                    </ToggleButtonGroup> :
                                    <ToggleButtonGroup
                                        value={elementStatus}
                                        exclusive
                                        onChange={this.handleStatusChange}
                                        aria-label="text alignment"
                                    >
                                        {
                                            Object.keys(this.props.metamodel.task.values || []).map((i) =>
                                                <ToggleButton
                                                    key={i}
                                                    value={this.props.metamodel.task.values[i]}
                                                    className="toggle"
                                                >
                                                    {this.props.metamodel.task.values[i]}
                                                </ToggleButton>
                                            )
                                        }
                                    </ToggleButtonGroup>)
                                }

                                {!this.props.create &&
                                    <Link
                                        component="button"
                                        style={plannedDatesStyle}
                                        className="planned-dates"
                                        onClick={() => {
                                            this.setState({setTimeOpen: true});
                                        }}
                                    >
                                        {plannedDates}
                                    </Link>
                                }
                            </div> :
                            <div className="leftButtons"/>
                        }

                        {showButtons &&
                            <div className="rightButtons">
                                {element.type !== 'Product' && this.props.onStartMove &&
                                    <Tooltip title="Move">
                                        <IconButton aria-label="move" onClick={() => this.props.onStartMove(element)}>
                                            <ControlCameraIcon />
                                        </IconButton>
                                    </Tooltip>
                                }
                                {element.type !== 'Product' &&
                                    <Tooltip title="Delete">
                                        <IconButton aria-label="delete" onClick={this.remove}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                }
                            </div>
                        }
                        {(this.state.editName || this.state.editDescription) &&
                            <div className="rightButtons">
                                <Button variant="contained" onClick={this.cancel}>
                                    Cancel
                                </Button>
                                {/* React warns that the component is changed from uncontrolled to controlled when values becomes non empty. */}
                                <Button variant="contained" onClick={this.save}
                                    disabled={!values.name}
                                >
                                    Save
                                </Button>
                            </div>
                        }
                    </div>
                </div>

                {this.props.showTasks &&
                    (this.props.element.type === 'Requirement' || this.props.element.type === 'Card') &&
                    <TaskList
                        metamodel={this.props.metamodel}
                        globals={this.props.globals}
                        parent={element}
                        tasks={metamodelRequirements.tasks(element)}
                        user={this.props.user}
                        users={this.props.users}
                        userMap={this.props.userMap}
                        filter={this.props.filter}
                        newTask={this.props.newTask}
                        createTask={this.createTask}
                        removeTask={this.removeTask}
                        showHeader={true}
                        showDetails={true}
                        showNoTasks={true}
                    />
                }

                <SetTimeDialog
                    element={element}
                    open={this.state.setTimeOpen}
                    onClose={() => this.setState({setTimeOpen: false})}
                    onSave={this.onSetTime}
                />
                <ConfirmationDialog
                    title={"Remove " + typeName.toLocaleLowerCase()}
                    text={"Remove '" + this.props.element.name + "'?"}
                    open={this.state.confirmationOpen}
                    onOK={this.removeOK}
                    onCancel={this.removeCancel}
                />
            </div>
        );
    }

    remove() {
        this.setState({confirmationOpen: true} );
    }

    removeCancel() {
        this.setState({confirmationOpen: false} );
    }

    removeOK() {
        this.props.remove(this.props.element);
        this.setState({confirmationOpen: false} );
    }

    move() {
        console.log("Move not implemented");

    }

    cancel() {
        this.setState({
            editName: false,
            editDescription: false,
            name: undefined,
            type: undefined,
            description: undefined,
            status: undefined,
            assigned: undefined,
        });
        if(this.props.onCancel) {
            this.props.onCancel();
        }
    }

    save() {
        console.log("save element:", this.props.element, "state:", this.state);

        if(this.props.create) {
            let values = {
                name: this.state.name || this.props.element.name,
                description: this.state.description,

                // FIXME Category does not have status or assigned, but Card does.
                // status: this.state.status || this.props.element.status,
                status: this.props.element.status,

                // assigned: this.state.assigned,
            };
            this.saveNewElement(values);
        } else {
            let values = {
                name: this.state.name,
                description: this.state.description,
                assigned: this.state.assigned,
            };
            this.updateElement(values);
        }
    }

    updateElement(values) {
        const element = this.props.element;

        return this.props.globals.updateElement(element, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    this.elementUpdated(result);
                    this.cancel();
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    elementUpdated(values) {
        const element = this.props.element;
        Object.assign(element, values);
        this.props.onRequirementUpdate(element);
    }

    saveNewElement(values) {
        let parent = this.state.parent || this.props.parent || this.props.categories[0];
        let collection = this.props.collection;

        console.log("saveNewElement parent:", parent, "collection:", collection, "values:", values);

        this.props.globals.createChild(parent, collection, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    this.props.onChildAdded(parent, result);
                },
                (error) => {
                    console.error(error);
                }
            )
    };

    createTask(values) {
        let parent = this.props.element;
        let collection = "tasks";

        console.log("createTask parent:", parent, "collection:", collection, "values:", values);

        return this.props.globals.createChild(parent, collection, values)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log("Result", result);
                    parent.tasks.push(result);
                    this.setState({updatedTime: new Date()});
                },
                (error) => {
                    console.error(error);
                }
            )
    };

    removeTask(element) {
        // TODO Confirm or undo remove task.
        let parent = this.props.element;

        console.log("RequirementDetails.removeTask", element);

        this.props.globals.deleteElement(element)
            .then(
                (result) => {
                    console.log("Result", result);
                    let ix = parent.tasks.indexOf(element);
                    console.log("index:", ix);
                    delete parent.tasks[ix];
                    this.setState({updatedTime: new Date()});
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    handleStatusChange(event, newStatus) {
        const element = this.props.element;
        if(newStatus && newStatus !== element.status) {
            if(this.props.create) {
                this.setState({status: newStatus});
            } else {
                this.updateElement({
                    status: newStatus
                }).then(
                    () => {
                        this.setState({
                            version: new Date().getTime()
                        });
                    }
                );
            }
        }
    }

    onSetTime(values) {
        console.log("onSetTime", values);
        this.updateElement(values);
    }

    _handleTextFieldChange(e) {
        // console.log("_handleTextFieldChange", e.target.id, e.target.value);
        var newState = {};
        newState[e.target.id] = e.target.value;
        this.setState(newState);
    }

    handleSelect(id, value) {
        console.log("handleSelect", id, value);
        var newState = {};
        newState[id] = value;
        this.updateElement(newState);
    }
}

export default RequirementDetails;